export const PERMISSION_CONSTANTS = {
    VIEW_INSTRUCTOR: 'viewInstructor',
    VIEW_STUDENT: 'viewStudent'
}